"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FormInputPinStyle = {
    parts: ['appendix', 'button', 'buttonContainer', 'container', 'pinInputContainer', 'pinInputField', 'pinInputValid'],
    baseStyle: {
        appendix: {
            width: '0',
            minWidth: '100%',
            gap: 10,
        },
        button: {
            fontSize: 'sm',
            fontWeight: 'normal',
            textDecorationLine: 'underline',
            _hover: {
                color: 'blue.600',
                _disabled: {
                    color: 'blue.500',
                },
            },
            _disabled: { opacity: 0.35, cursor: 'not-allowed' },
        },
        buttonContainer: { marginLeft: 'auto' },
        container: { gap: 3 },
        pinInputContainer: { justifyContent: 'space-between', gap: 2.5 },
        pinInputField: {
            fontWeight: 'normal',
            borderColor: 'gray.300',
            lineHeight: {
                base: '2.3rem',
                '2xs': '2.3rem',
                xs: '2.3rem',
                sm: '2.3rem',
                md: '2.3rem',
                lg: '2.6rem',
                xl: '2.6rem',
                '2xl': '2.6rem',
            },
            fontSize: { base: '2xl', md: '2xl', lg: '3xl' },
            width: {
                base: '3rem',
                '2xs': '3rem',
                xs: '3rem',
                sm: '3rem',
                md: '3rem',
                lg: '3.75rem',
                xl: '3.75rem',
                '2xl': '3.75rem',
            },
            height: '3.75rem',
            _focus: { borderColor: 'notification.blue' },
            '&[aria-invalid=true]': {
                borderColor: 'red.400',
                boxShadow: 'none',
            },
        },
        pinInputValid: {
            borderColor: 'green.400',
            boxShadow: 'none',
        },
    },
};
exports.default = FormInputPinStyle;
